var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLivegame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44077 4.13123C3.66741 3.03254 3.84808 1.51893 4.82105 0.643117L7.7721 4.83522C6.6647 5.51992 5.21419 5.22985 4.44068 4.1313L4.44077 4.13123ZM3.47548 9.18714V10.6165C3.47548 11.1247 4.17042 11.1342 4.17042 10.6067V7.70052L4.8375 7.17534C5.10771 6.96255 4.63961 6.25186 4.34819 6.47251C3.82395 6.86944 3.29986 7.26637 2.77562 7.6633C3.10494 8.11089 3.46602 8.64022 3.47548 9.18722V9.18714ZM1.22777 7.78247C1.38566 8.0068 1.6931 8.05732 1.91005 7.89395L5.24719 5.38144C4.31623 5.07807 3.52007 3.9474 3.53765 2.95317L0.200697 5.46568C-0.0163329 5.62912 -0.0651803 5.94572 0.0927043 6.16997L1.22777 7.78247ZM5.18704 0.368347L8.1381 4.56045C9.11106 3.68464 9.2919 2.17095 8.51845 1.07235C7.74501 -0.0264191 6.29457 -0.316482 5.18702 0.368347H5.18704Z",
    fill: "#8D8E92"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivegame);
export default __webpack_public_path__ + "static/media/livegame.951c2f8c8ec9e6ca3a6e6604d9ced640.svg";
export { ForwardRef as ReactComponent };